import GlobalAnimationSearch from './globalAnimationSearch';

interface GlobalSearchProps {
  onSearch: (value: boolean) => void;
}

export const GlobalSearch = ({ onSearch }: GlobalSearchProps) => {
  return <GlobalAnimationSearch handleSearch={onSearch} />;
  // return <></>
};
